import React from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'
import { useTranslationRankmi } from 'helpers/translations.helper'
import restartEvaluationResults from 'api/administration/monitoring/restartEvaluationResults'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { IMainState } from 'store/states'
import { translationPrefix } from '../constants'

interface ButtonKeepProps {
  courseId: string
  onSuccess: () => void
}

export function ButtonKeep({ courseId, onSuccess }: ButtonKeepProps) {
  const t = useTranslationRankmi({
    prefix: translationPrefix,
  })

  const { edit } = useSelector(({ blocks }: IMainState) => blocks)

  const [loading, setLoading] = React.useState(false)

  return (
    <CommonToolTip text={t('actions.keep.tooltip')} position="top">
      <Button
        disabled={loading}
        onClick={async () => {
          setLoading(true)
          try {
            if (edit.id) {
              await restartEvaluationResults(courseId, edit.id, {
                sendReport: true,
                keepAdvance: true,
              })
              SuccessToast(t('toasts.changeToProgress.success'))
            }
            onSuccess()
          } catch (e) {
            ErrorToast(t('toasts.changeToProgress.error'))
          }
          setLoading(false)
        }}
        className="h-100 w-100 d-flex align-items-center justify-content-center"
      >
        {loading ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          <FontAwesomeIcon icon={faLock} />
        )}
        <span className="ml-2">{t('actions.keep.text')}</span>
      </Button>
    </CommonToolTip>
  )
}
